import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {environment} from '../../../environments/environment';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserViewService {
  constructor(private http: HttpClient) {}

  public captureView(data) {
    const {diagramId, state, source} = data;

    return this.http
      .post<any>(`${environment.API_ENDPOINT}/view-record/${diagramId}/state/${state}`, {
        source: source
      })
      .pipe(take(1));
  }
}
